export default __webpack_public_path__ + "static/media/7.3e978820.webp";